import { DBObject } from './db-object.js';
export class DBColumn extends DBObject {
    table;
    name;
    type;
    maxLength; // Optional length for VARCHAR or other types that require it
    defaultValue;
    isNullable;
    isPrimaryKey = false;
    constructor(options) {
        super();
        this.table = options.table;
        this.name = options.name;
        this.type = options.type;
        this.maxLength = options.maxLength;
        this.defaultValue = options.defaultValue ?? '';
        this.isNullable = options.isNullable ?? true;
        this.isPrimaryKey = options.isPrimaryKey ?? false;
    }
}
